import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { useAuthStore } from '../store/authStore';
import { useTranslation } from '../i18n';

export default function MaintenancePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [message, setMessage] = useState(t('maintenance_message'));

  const handleBackToLogin = () => {
    // Logout and then navigate to login (without maintenance check)
    useAuthStore.getState().logout();
  };

  useEffect(() => {
    // Try to fetch the maintenance message from the API
    const fetchMessage = async () => {
      try {
        const response = await apiClient.get('/system/maintenance/web');
        if (response.data?.data?.message) {
          setMessage(response.data.data.message);
        }
      } catch (err) {
        // Use default message if API call fails
        console.error('Failed to fetch maintenance message:', err);
      }
    };

    fetchMessage();
  }, []);

  return (
    <div style={page}>
      <div style={topBar}>
        <span style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>Lot'N'Go</span>
      </div>
      <div style={body}>
        <div style={{ fontSize: '48px', fontWeight: 800, color: '#111', marginBottom: '8px', fontFamily: "'Manrope', system-ui, sans-serif" }}>
          🔧
        </div>
        <div style={{ fontSize: '18px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>
          {t('maintenance_title')}
        </div>
        <div style={{ fontSize: '14px', color: '#9ca3af', marginBottom: '24px', maxWidth: '280px' }}>
          {message}
        </div>
        <button onClick={handleBackToLogin} style={btn}>
          {t('back_to_login')}
        </button>
      </div>
    </div>
  );
}

const page: React.CSSProperties = {
  display:         'flex',
  flexDirection:   'column',
  minHeight:       '100dvh',
  maxWidth:        '430px',
  margin:          '0 auto',
  backgroundColor: '#f8f9fa',
  fontFamily:      "'Inter', system-ui, -apple-system, sans-serif",
};

const topBar: React.CSSProperties = {
  display:              'flex',
  alignItems:           'center',
  justifyContent:       'center',
  padding:              '0 16px',
  height:               '44px',
  backgroundColor:      'rgba(248,249,250,0.85)',
  backdropFilter:       'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
};

const body: React.CSSProperties = {
  flex:           1,
  display:        'flex',
  flexDirection:  'column',
  alignItems:     'center',
  justifyContent: 'center',
  padding:        '24px',
  textAlign:      'center',
};

const btn: React.CSSProperties = {
  display:      'block',
  width:        '100%',
  maxWidth:     '240px',
  height:       '44px',
  borderRadius: '8px',
  border:       'none',
  background:   'linear-gradient(135deg, #005bc0, #004fa9)',
  color:        '#f7f7ff',
  fontSize:     '14px',
  fontWeight:   600,
  cursor:       'pointer',
};
